import * as React from 'react';
import {
    getConfig,
    getExperimentVariantFromConfig,
    getFeatureStatus,
} from '../../config';
import { ContentMarketing, MarketingLabel } from './content-marketing';
import { escape } from '../../utils/component/helpers';
import { UNLEASH_FEATURE_NAMES } from '../../../shared/unleash-feature-names';
import { replaceLastCharacterOfString } from '../../utils/string';
import { ErrorBoundary } from '../error-boundary';

type Props = {
    id: string;
    isFrontpage?: boolean;
};

export type MarketContentDesignExperimentVariants =
    | undefined
    | 'control'
    | 'challengerSplitView';

function ContentMarketingContainer(props: Props) {
    const contentMarketingList = getConfig()?.contentMarketing;
    const marketContentDesignVariant = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.enableMarketContentDesignExperiment,
    ) as MarketContentDesignExperimentVariants;

    const splitViewContentMarketEnabled = getFeatureStatus(
        UNLEASH_FEATURE_NAMES.enableMarketContentSplitView,
    );

    if (contentMarketingList.length > 0) {
        if (
            !splitViewContentMarketEnabled ||
            marketContentDesignVariant === 'control'
        ) {
            return (
                <ContentMarketing
                    positionId={props.id}
                    contentMarketing={contentMarketingList[0]}
                    isFrontpage={props.isFrontpage}
                />
            );
        } else if (contentMarketingList.length === 1) {
            return (
                <ContentMarketing
                    positionId={props.id}
                    contentMarketing={contentMarketingList[0]}
                    isFrontpage={props.isFrontpage}
                />
            );
        } else if (contentMarketingList.length > 1) {
            return (
                <div
                    className={`relative transition-all ${
                        props.isFrontpage
                            ? 'my-16'
                            : 'mx-16 mt-24 mb-16 sm:mb-24'
                    }`}
                >
                    <MarketingLabel
                        justifyBetween={false}
                        escapedIconUrl={escape(
                            contentMarketingList[0].icon.url,
                        )}
                        escapedSponsor={escape(contentMarketingList[0].sponsor)}
                    />
                    <div className={'flex flex-row gap-16'}>
                        {contentMarketingList.map((contentMarketing, i) => (
                            <ContentMarketing
                                key={contentMarketing.id}
                                positionId={replaceLastCharacterOfString(
                                    props.id,
                                    `${i + 1}`,
                                )}
                                contentMarketing={contentMarketing}
                                isFrontpage={props.isFrontpage}
                                rowIndex={i}
                            />
                        ))}
                    </div>
                </div>
            );
        }
    } else return null;
}

const ContentMarketingContainerWithErrorBoundary = (props: Props) => (
    <ErrorBoundary fallback={null}>
        <ContentMarketingContainer {...props} />
    </ErrorBoundary>
);

export default ContentMarketingContainerWithErrorBoundary;
